//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import XLSX from "xlsx"; // import xlsx
import axios, { CancelToken } from "axios";

export default {
  data() {
    return {
      api: `${this.$apiFix}`,
      loading: false,
      UserAccessData: {},
      Readiness: {},
      processStatus: "ALL",
      grp: "ALL",
      team: "ALL",
      teams: [],
      mers: [],
      mer: "ALL",
      cntLate: 0,
      cntAlert: 0,
      cntNormal: 0,
      block1: [],
      block2: [],
      currentPage: 1,
      maxPage: 0,
      fnt: "fnt1",
      visible: false,
      loadFirst: true
    };
  },
  created() {
    // console.log('Readiness Document 2021')
    // console.log(this.$route.params.grp)
    // console.log(this.$route.params.team)

    this.grp = this.$route.params.grp;
    this.team = this.$route.params.team;
  },
  async mounted() {
    this.chkAuthen("", "");
    const getRole = this.getUserPublic();
    const getRoleArray = await Promise.all([getRole]);
    this.UserAccessData = getRoleArray[0];
    // console.log(this.UserAccessData)
    // console.log("Mounted");

    this.getData();
    this.pullData();
    this.loadFirst = false;
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      this.changePage();
    },
    processStatus: function(newValue, oldValue) {
      this.getData();
    },
    grp: function(newValue, oldValue) {
      if (this.loadFirst == false) {
        this.team = "ALL";
        this.mer = "ALL";
      }
      this.getData();
    }
  },
  methods: {
    pullData() {
      this.pulling = setInterval(() => {
        var currentdate = new Date();
        if (
          currentdate.getMinutes() % 5 == 0 &&
          currentdate.getSeconds() == 0
        ) {
          this.getData();
        }
      }, 1000);
    },
    getData() {
      this.visible = true;
      this.currentPage = 1;
      this.maxPage = 0;
      let params = new FormData();
      params.append("grpin", this.UserAccessData.MerIn);
      params.append("grp", this.grp);
      params.append("team", this.team);
      params.append("mer", this.mer);
      params.append("page", this.currentPage);
      params.append("status", this.processStatus);

      axios
        .post(this.$apiFix + "2020ReadinessSum.php/wip_doc_detail", params)
        .then(response => {
          // console.log(response.data)
          this.Readiness = response.data;
          this.cntLate = this.Readiness.sum[0].LATE;
          this.cntAlert = this.Readiness.sum[0].ALERT;
          this.cntNormal = this.Readiness.sum[0].NORMAL;
          this.maxPage = this.Readiness.totalpages;
          this.block1 = this.Readiness.arrPage[0];
          this.block2 = this.Readiness.arrPage[1];
          this.visible = false;

          this.getMasterMer();
          this.getMasterTeam();
        })
        .catch(err => {
          console.error(err);
        });
    },
    ExportExcel() {
      this.loading = true;
      let params = new FormData();
      params.append("grp", this.grp);
      axios
        .post(`${this.api}export.php/ppr_doc`, params)
        .then(response => {
          //   console.log(response.data);
          const dataWS = XLSX.utils.json_to_sheet(response.data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataWS);
          XLSX.writeFile(wb, "export-doc-" + this.grp + ".xlsx");
          this.loading = false;
        })
        .catch(err => {
          console.error(err);
          this.loading = false;
        });
    },
    getMasterMer() {
      let params = new FormData();
      params.append("grpin", this.UserAccessData.MerIn);
      params.append("grp", this.grp);
      params.append("team", this.team);

      axios
        .post(this.$apiFix + "2020ReadinessSum.php/wip_master_mer", params)
        .then(response => {
          // console.log(response.data)
          this.mers = response.data;
        })
        .catch(err => {
          console.error(err);
        });
    },

    getMasterTeam() {
      let params = new FormData();
      params.append("grpin", this.UserAccessData.MerIn);
      params.append("grp", this.grp);
      params.append("team", this.team);

      axios
        .post(this.$apiFix + "2020ReadinessSum.php/wip_master_team_mer", params)
        .then(response => {
          // console.log(response.data)
          this.teams = response.data;
        })
        .catch(err => {
          console.error(err);
        });
    },

    changePage() {
      this.visible = true;
      let params = new FormData();
      params.append("grpin", this.UserAccessData.MerIn);
      params.append("grp", this.grp);
      params.append("team", this.team);
      params.append("mer", this.mer);
      params.append("page", this.currentPage);
      params.append("status", this.processStatus);

      axios
        .post(this.$apiFix + "2020ReadinessSum.php/wip_doc_detail", params)
        .then(response => {
          // console.log(response.data);
          this.Readiness = response.data;
          this.cntLate = this.Readiness.sum[0].LATE;
          this.cntAlert = this.Readiness.sum[0].ALERT;
          this.cntNormal = this.Readiness.sum[0].NORMAL;
          this.teams = this.Readiness.teams;
          this.maxPage = this.Readiness.totalpages;
          this.block1 = this.Readiness.arrPage[0];
          this.block2 = this.Readiness.arrPage[1];
          this.visible = false;
        })
        .catch(err => {
          console.error(err);
        });
    },
    getLate(obj) {
      if (obj.TARGET_BY_RDD < obj.CWEEK) {
        return "bg-red-2 text-black";
      } else if (obj.TARGET_BY_RDD == obj.CWEEK) {
        return "bg-yellow-2 text-black";
      } else {
        return "bg-green-2 text-black";
      }
    },
    getShow(obj) {
      if (this.processStatus == "ALL") {
        return true;
      } else {
        if (this.processStatus == "LATE") {
          if (obj.TARGET_BY_RDD < obj.CWEEK) {
            return true;
          } else {
            return false;
          }
        } else if (this.processStatus == "ALERT") {
          if (obj.TARGET_BY_RDD == obj.CWEEK) {
            return true;
          } else {
            return false;
          }
        } else {
          if (obj.TARGET_BY_RDD > obj.CWEEK) {
            return true;
          } else {
            return false;
          }
        }
      }
    }
  }
};
